"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postResendUserTempPassword = void 0;
/**
 * Allows you to resend the welcome message from Cognito to a user who's temp password has expired
 */
var postResendUserTempPassword = function (instance) {
    return function (body, config) {
        return instance.post("/users/resend-welcome-message", body, config);
    };
};
exports.postResendUserTempPassword = postResendUserTempPassword;
